var _rect, _rect2, _g, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.748047,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#DCEAFF",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 2,
    y: 2.74805,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3638_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.007 22.923L15.832 23.748L18.832 20.748L21.832 17.748L18.832 14.748L15.832 11.748L15.007 12.573L14.1797 13.4004L16.3523 15.573L18.5273 17.748L16.3523 19.923L14.1797 22.0957L15.007 22.923Z",
    fill: "#2E2E2E",
    fillOpacity: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.74805,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#2E2E2E",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3638_161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(0 -1 1 0 12 23.748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/Right_Button.8758d7ba5eba7bcbc18bc2bab379d632.svg";
export { ForwardRef as ReactComponent };